import { render } from "./ChallengeManagement.vue?vue&type=template&id=d5c34740&scoped=true"
import script from "./ChallengeManagement.vue?vue&type=script&lang=js"
export * from "./ChallengeManagement.vue?vue&type=script&lang=js"

import "./ChallengeManagement.vue?vue&type=style&index=0&id=d5c34740&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c34740"]])

export default __exports__